/* @flow */
import { push } from 'react-router-redux';
import { cancel, put, select, takeLatest, all } from 'redux-saga/effects';
import actionTypes from './actionTypes';
import { getCurrentPathname } from './selectors';

function* pushUseCase(action) {
  const currentPathname = yield select(getCurrentPathname);
  const { pathname } = action.payload;
  if (currentPathname === pathname) {
    yield cancel();
  }

  yield put(push(pathname));
}

export default function* routerSaga() {
  yield all([takeLatest(actionTypes.PUSH, pushUseCase)]);
}



// WEBPACK FOOTER //
// ./src/core/router/saga.js